import type { UserRole } from '@vigilo/shared';

const COMMAND_DASHBOARD_ROLES: ReadonlySet<UserRole> = new Set([
  'command_supervisor',
  'system_admin',
]);

const OPERATION_REQUIRED_PATHS = new Set([
  '/map',
  '/zones',
  '/alerts',
  '/command',
  '/movement',
  '/flags',
  '/reports',
]);

export function canViewCommandDashboard(role?: UserRole | string | null): boolean {
  return COMMAND_DASHBOARD_ROLES.has(role as UserRole);
}

// Entering an operation lands on the live map for every role: it is the picture a command centre works from. The
// Command Dashboard stays one click away in the menu for the roles that can view it.
export function defaultOperationEntryPath(_role?: UserRole | string | null): string {
  return '/map';
}

function operationPathFromRequestedPath(requestedPath?: string | null): string | null {
  if (!requestedPath || requestedPath === '/operations') return null;
  if (!requestedPath.startsWith('/')) return null;

  const parsed = new URL(requestedPath, window.location.origin);
  if (parsed.origin !== window.location.origin) return null;
  if (!OPERATION_REQUIRED_PATHS.has(parsed.pathname)) return null;

  return `${parsed.pathname}${parsed.search}`;
}

export function operationEntryPathForRole(
  role: UserRole | string | null | undefined,
  requestedPath?: string | null,
): string {
  const fallbackPath = defaultOperationEntryPath(role);
  const operationPath = operationPathFromRequestedPath(requestedPath);

  if (!operationPath) return fallbackPath;
  if (operationPath.startsWith('/command') && !canViewCommandDashboard(role)) return fallbackPath;

  return operationPath;
}
